module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "hide-overlay": "",
      "transition": "dialog-bottom-transition"
    },
    model: {
      value: (_vm.siteDialog),
      callback: function($$v) {
        _vm.siteDialog = $$v
      },
      expression: "siteDialog"
    }
  }, [_c('v-card', [(_vm.loading) ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close($event)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Site Info")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-btn', {
    attrs: {
      "dark": "",
      "flat": "",
      "disabled": _vm.customerID === null || !_vm.newSiteValid
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveSite(false)
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('v-form', {
    ref: "newSite",
    model: {
      value: (_vm.newSiteValid),
      callback: function($$v) {
        _vm.newSiteValid = $$v
      },
      expression: "newSiteValid"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-2 ma-2"
  }, [_c('v-subheader', [_vm._v("Location Info")]), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "label": "Customer",
      "items": _vm.customerArray,
      "item-text": "name",
      "item-value": "key",
      "rules": [function (v) { return !!v || 'Customer is required'; }],
      "required": ""
    },
    model: {
      value: (_vm.customerID),
      callback: function($$v) {
        _vm.customerID = $$v
      },
      expression: "customerID"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Site Name",
      "rules": [function (v) { return !!v || 'Name is required'; }],
      "required": ""
    },
    model: {
      value: (_vm.siteEditedItem.Name),
      callback: function($$v) {
        _vm.$set(_vm.siteEditedItem, "Name", $$v)
      },
      expression: "siteEditedItem.Name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Address",
      "rules": [function (v) { return !!v || 'Address is required'; }],
      "required": ""
    },
    model: {
      value: (_vm.siteEditedItem.Address),
      callback: function($$v) {
        _vm.$set(_vm.siteEditedItem, "Address", $$v)
      },
      expression: "siteEditedItem.Address"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Town/City",
      "rules": [function (v) { return !!v || 'Town/City is required'; }],
      "required": ""
    },
    model: {
      value: (_vm.siteEditedItem.Town),
      callback: function($$v) {
        _vm.$set(_vm.siteEditedItem, "Town", $$v)
      },
      expression: "siteEditedItem.Town"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Post Code",
      "rules": [function (v) { return !!v || 'Post Code is required'; }],
      "required": ""
    },
    model: {
      value: (_vm.siteEditedItem.PostCode),
      callback: function($$v) {
        _vm.$set(_vm.siteEditedItem, "PostCode", $$v)
      },
      expression: "siteEditedItem.PostCode"
    }
  })], 1), _vm._v(" "), _c('v-card', {
    staticClass: "pa-2 ma-2"
  }, [_c('v-subheader', [_vm._v("Contacts Info")]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "value": !_vm.newSiteValid,
      "color": "warning",
      "icon": "priority_high"
    }
  }, [_vm._v("\n          Site must be valid before you can add contacts\n        ")]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "value": _vm.newSiteValid,
      "color": "info",
      "icon": "info",
      "outline": ""
    }
  }, [_vm._v("\n          To assign an existing contact, find in table below, 'click' on them and assign via contact dialog.\n        ")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Show All Customer Contacts",
      "color": "primary",
      "hide-details": ""
    },
    model: {
      value: (_vm.showAllContacts),
      callback: function($$v) {
        _vm.showAllContacts = $$v
      },
      expression: "showAllContacts"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "small": "",
      "disabled": !_vm.newSiteValid
    },
    on: {
      "click": function($event) {
        _vm.selectedKey = null;
        _vm.saveSite(true)
      }
    }
  }, [_vm._v("Add New Contact")])], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.filteredContacts,
      "pagination": _vm.pagination
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.saveSite(true);
              _vm.selectedKey = props.item.key;
              _vm.contactDialog = true;
              _vm.selectedCustomer = props.item.Customer
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.Name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.EmailAddress))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.Phone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.Mobile))]), _vm._v(" "), _c('td', [(props.item.Fleet) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-chip', {
          attrs: {
            "slot": "activator",
            "small": ""
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("mdi-truck")])], 1), _vm._v(" "), _c('span', [_vm._v("Fleet")])], 1) : _vm._e(), _vm._v(" "), (props.item.Comms) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-chip', {
          attrs: {
            "slot": "activator",
            "small": ""
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("mdi-phone")])], 1), _vm._v(" "), _c('span', [_vm._v("Comms")])], 1) : _vm._e(), _vm._v(" "), (props.item.Accounts) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-chip', {
          attrs: {
            "slot": "activator",
            "small": ""
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("mdi-cash-100")])], 1), _vm._v(" "), _c('span', [_vm._v("Accounts")])], 1) : _vm._e()], 1)])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-2 ma-2"
  }, [_c('v-subheader', [_vm._v("Opening times")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Mon/Fri",
      "mask": "##:## - ##:##"
    },
    model: {
      value: (_vm.siteEditedItem.MonFriOpening),
      callback: function($$v) {
        _vm.$set(_vm.siteEditedItem, "MonFriOpening", $$v)
      },
      expression: "siteEditedItem.MonFriOpening"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Sat",
      "mask": "##:## - ##:##"
    },
    model: {
      value: (_vm.siteEditedItem.SatOpening),
      callback: function($$v) {
        _vm.$set(_vm.siteEditedItem, "SatOpening", $$v)
      },
      expression: "siteEditedItem.SatOpening"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Sun",
      "mask": "##:## - ##:##"
    },
    model: {
      value: (_vm.siteEditedItem.SunFriOpening),
      callback: function($$v) {
        _vm.$set(_vm.siteEditedItem, "SunFriOpening", $$v)
      },
      expression: "siteEditedItem.SunFriOpening"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Preferred Install Time",
      "mask": "##:## - ##:##"
    },
    model: {
      value: (_vm.siteEditedItem.InstallTime),
      callback: function($$v) {
        _vm.$set(_vm.siteEditedItem, "InstallTime", $$v)
      },
      expression: "siteEditedItem.InstallTime"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Avoid Times",
      "mask": "##:## - ##:##"
    },
    model: {
      value: (_vm.siteEditedItem.AvoidTimes),
      callback: function($$v) {
        _vm.$set(_vm.siteEditedItem, "AvoidTimes", $$v)
      },
      expression: "siteEditedItem.AvoidTimes"
    }
  })], 1), _vm._v(" "), _c('v-card', {
    staticClass: "ma-2 pa-2"
  }, [_c('v-subheader', [_vm._v("Extra Info")]), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Is Head Office?"
    },
    model: {
      value: (_vm.headOffice),
      callback: function($$v) {
        _vm.headOffice = $$v
      },
      expression: "headOffice"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Site Access Restrictions"
    },
    model: {
      value: (_vm.siteEditedItem.Restrictions),
      callback: function($$v) {
        _vm.$set(_vm.siteEditedItem, "Restrictions", $$v)
      },
      expression: "siteEditedItem.Restrictions"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "label": "Other Notes"
    },
    model: {
      value: (_vm.siteEditedItem.Notes),
      callback: function($$v) {
        _vm.$set(_vm.siteEditedItem, "Notes", $$v)
      },
      expression: "siteEditedItem.Notes"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('contact-edit-dialog', {
    attrs: {
      "customer": _vm.selectedCustomer,
      "customers": _vm.customers,
      "contactDialog": _vm.contactDialog,
      "contactID": _vm.selectedKey,
      "siteID": _vm.editedSite
    },
    on: {
      "getContacts": _vm.getContacts,
      "update:contactDialog": function($event) {
        _vm.contactDialog = $event
      },
      "update:contact-dialog": function($event) {
        _vm.contactDialog = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05f936d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/SiteEditDialog.vue
// module id = 731
// module chunks = 1